import { apiFetch } from './client';

// Admin-only: all endpoints here require a platform_admin token on the wire.
// The dealer onboarding UI consumes `config`, `validation`, `publish`,
// `pause`, and `testCall` — secrets are returned masked; never send raw
// secrets back on a PATCH unless the admin actually typed a new value.
export const dealersApi = {
  list: (params) => apiFetch('/api/dealers', { params }),
  get: (id) => apiFetch(`/api/dealers/${id}`),
  create: (payload) => apiFetch('/api/dealers', { method: 'POST', body: payload }),
  update: (id, payload) =>
    apiFetch(`/api/dealers/${id}`, { method: 'PATCH', body: payload }),

  // --- Phase 2: config / onboarding ---------------------------------------
  getConfig: (id) => apiFetch(`/api/dealers/${id}/config`),
  patchConfig: (id, patch) =>
    apiFetch(`/api/dealers/${id}/config`, { method: 'PATCH', body: patch }),
  validation: (id) => apiFetch(`/api/dealers/${id}/validation`),
  publish: (id) =>
    apiFetch(`/api/dealers/${id}/publish`, { method: 'POST', body: {} }),
  pause: (id, reason) =>
    apiFetch(`/api/dealers/${id}/pause`, { method: 'POST', body: { reason } }),
  testCall: (id, to_number) =>
    apiFetch(`/api/dealers/${id}/test-call`, {
      method: 'POST',
      body: { to_number },
    }),
};
